import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
import axios from '../apiClient';
import Alert from '../alert';
import useSound from 'use-sound';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
// assets
import { IconMenu2,IconCoin } from '@tabler/icons';
import notiSound from '../../assets/music/referee-whistle.mp3';
import { useEffect, useState,useRef} from 'react';
import jwtDecode from 'jwt-decode';
import { useNavigate } from 'react-router';
import { Switch } from 'antd';
import { use } from 'react';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle,socket}) => {
    const [ownerName,setOwnerName] = useState('')
    const navigate = useNavigate()
    const [errorMsg, setErrorMsg] = useState({});
    const [openAlert, setOpenAlert] = useState(false);
    const [amount,setAmount] = useState(0);
    const [notiCount, setNotiCount] =  useState(Number(localStorage.getItem("notiCount") || 0));
    // get data from backend when componenet is first mounted
    async function fetchData() {
    const token = localStorage.getItem("token");
    const {id: holderId,name} = jwtDecode(token);

    let data = await axios.get(`/wallet/getAmount?holderId=${holderId}`)
    if (data.code != 200) {
        setErrorMsg({ code: data.code, msg: data.message })
        setOpenAlert(true)
        return
    }
    setAmount(data.data.amount)
    setOwnerName(name)
    }
    //--------------------------------------------------
        
    const [playNoti] = useSound(notiSound);
    const hiddenDivRef = useRef(null);

    const [autoAudit,setAutoAudit] = useState(false);

    const mounted = useRef(false);

    useEffect(()=>{
        const triggerSound = () => {
            if (hiddenDivRef.current) {
              hiddenDivRef.current.click();
            }
        };
    
        socket.on('matchConfirmed',()=> {
            
            triggerSound();
            const currentCount = Number(document.getElementById('noti')?.innerHTML || "0");
            const updatedCount = currentCount + 1;
            localStorage.setItem("notiCount",updatedCount);
            if(document.getElementById('noti')){
                document.getElementById('noti').innerHTML = updatedCount;
            }else{
                setNotiCount(updatedCount);
            }
        });
        fetchData()
        return () => {
            socket.off('matchConfirmed');
        };
    },[])
    const theme = useTheme();

    const handleLogout = () =>{
        localStorage.removeItem("token");
        navigate('/login')
    }
    const handleCloseAlert =()=>{
        setOpenAlert(false)
    }

    const callAuditUpdateApi = async(bool)=> {
        const data = await axios.put(`/owner/updateAuditorConfig`, {
            "mode": bool ? "auto" : "manual" // auto or manual
        });
        setErrorMsg({ code: data.code, msg: data.message })
        setOpenAlert(true)
    }

    const getAuditConfig = async()=> {
        const res = await axios.get(`/owner/getAuditorConfig`);
        if(res.code == 200){
            setAutoAudit(res.data.verify_mode == "auto");
        }else{
            setAutoAudit(false);
        }
    }

    useEffect(()=>{
        mounted.current = true;
        getAuditConfig();
    },[])

    return (
        <>
             <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
            {/* logo & toggler button */}
            <div
                ref={hiddenDivRef}
                style={{ display: 'none' }}
                onClick={playNoti}
            />
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.secondary.light,
                            color: theme.palette.secondary.dark,
                            '&:hover': {
                                background: theme.palette.secondary.dark,
                                color: theme.palette.secondary.light
                            }
                        }}
                        onClick={handleLeftDrawerToggle}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase>
            </Box>

            {/* header search */}
            {/* <SearchSection /> */}
            {/* <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} /> */}
             <div style={{display: "flex",justifyContent: "space-between",alignItems: "center",width: "100%"}}>
                 <h3 style={{marginLeft: "2rem"}} >Owner Dashboard</h3>
                  <div style={{display: "flex",justifyContent: "space-between",alignItems: "center"}}>
                        <div style={{ color: "#364152",marginRight: "0.5rem", fontWeight: "bold"}}>
                            Auto Audit
                        </div>
                        <div>
                            <Switch  checked={autoAudit} onChange={(checked)=> {
                                setAutoAudit(checked);
                                callAuditUpdateApi(checked);
                            }} style={{marginRight: "2rem"}} />
                        </div>
                       <div style={{display: "flex",alignItems: "center"}}>
                          <IconCoin color='#0E8388'/>
                          <h3 style={{marginRight: "80px"}}><span style={{fontWeight: 'normal'}}>Units:</span><span style={{fontWeight: 'bold',marginLeft: "0.2rem"}}>{Number(amount).toLocaleString()}</span> </h3>
                      </div>
                      <h3 style={{marginRight: "1rem"}}>{ownerName}</h3>
                      <ButtonBase style={{position: "relative"}} onClick={()=>{
                        navigate('/reports/matchResult');
                        localStorage.setItem("notiCount",0);
                        setNotiCount(0)
                      }}>
                        {/* <img src={require("../../assets/icons/bell.svg").default} style={{width: "2.5rem",height: "2.5rem",color: "rgb(103, 58, 183)"}}/> */}
                        <CircleNotificationsIcon style={{width: "2.5rem",height: "2.5rem",color: "#673AB7"}}/>
                        {notiCount > 0 && <div style={{width: "1rem",height: "1rem",backgroundColor: "#E25050",borderRadius: "4.1rem",position:"absolute",left: "60%",top: 0}}>
                            <h1 id='noti' style={{fontSize: "0.9rem",textAlign: "center",margin: 0}} className='white'>{notiCount}</h1> 
                        </div>}
                    </ButtonBase>
                      <ButtonBase style={{marginRight: "1rem",marginLeft: "5rem",borderRadius: "1rem"}} onClick={handleLogout}>
                          <h3>Logout</h3>
                      </ButtonBase>
                  </div>
             </div>
            {/* <ProfileSection /> */}
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
